import { render, staticRenderFns } from "./Header_V2.vue?vue&type=template&id=17435056&scoped=true"
import script from "./Header_V2.vue?vue&type=script&lang=js"
export * from "./Header_V2.vue?vue&type=script&lang=js"
import style0 from "./Header_V2.vue?vue&type=style&index=0&id=17435056&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17435056",
  null
  
)

export default component.exports